import { useState } from "react";

// Encapsulates the panel's checkbox-selection state. Mirrors the original
// Boolean-toggle behavior exactly: clicking a single checkbox always clears
// the "select all" flag, and clicking "select all" again deselects everything.
const useTTSAccessibilityTagsSelection = (ttsAccessibilityTags) => {
  const [selectedTags, setSelectedTags] = useState([]);
  const [selectAll, setSelectAll] = useState(false);

  const handleSelectAllCheckBox = () => {
    if (!selectAll) {
      setSelectedTags(ttsAccessibilityTags.map((el) => el.identifier));
      setSelectAll(true);
    } else {
      setSelectedTags([]);
      setSelectAll(false);
    }
  };

  const handleCheckBox = (e) => {
    const val = e.target.value;
    if (selectedTags.includes(val)) {
      setSelectedTags(selectedTags.filter((id) => id !== val));
    } else {
      setSelectedTags([...selectedTags, val]);
    }
    setSelectAll(false);
  };

  const clearSelection = () => {
    setSelectedTags([]);
    setSelectAll(false);
  };

  return {
    selectedTags,
    selectAll,
    handleSelectAllCheckBox,
    handleCheckBox,
    clearSelection,
  };
};

export { useTTSAccessibilityTagsSelection };
